import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { SearchText } from '../../../../observation/model/searchTexts.model';
import { BaseService } from '../../../../shared/services/base.service';
import { CommonService } from '../../../../shared/services/common.service';
import { PTWGasTestRecord } from '../../model/PTWGasTestRecord.model';
import { PTWPermission } from '../../model/PTWPermission.model';

@Component({
  selector: 'ara-ptw-gas-test-record-table',
  templateUrl: './ptw-gas-test-record-table.component.html',
  styleUrls: ['./ptw-gas-test-record-table.component.css']
})
export class PtwGasTestRecordTableComponent implements OnInit {

  @Output() onGasRecordUpdate = new EventEmitter();

  @Input()
  inputRecords: PTWGasTestRecord[];

  @Input()
  PermitId: number = 0;

  @Input()
  LastValueOfRecord: any = 1;

  @Input()
  Permissions: PTWPermission = new PTWPermission();

  @Input()
  addRecords : boolean;

  @Input()
  initialTextForTextArea : string = "";


  loggedInUserJSON: any;

  inputRecord: PTWGasTestRecord = { date: new Date(), result: '', user: 0,PermitId:this.PermitId };

  productDialog: boolean = false;

  gasTestRecords: PTWGasTestRecord[];

  clonedProducts: { [s: string]: PTWGasTestRecord; } = {};
  IsRecordNeedToAdd: boolean = false;
  IsEdatable: boolean = false;
  searchTexts: SearchText;
  allUsers: any[] = [];
  lastValue : number = 1;



  constructor(private baseService: BaseService, private commonService: CommonService) {
    this.searchTexts = new SearchText();

  }

  ngOnInit(): void {
    this.getAllUsers();
    if (!this.inputRecords) {
      this.inputRecords = [];
    }
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.lastValue = this.LastValueOfRecord;
  }

  getAllUsers() {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }

  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response.Success) {
      this.allUsers = response.Result;
      if (this.allUsers && this.allUsers.length) {
        this.inputRecords.forEach(s => {
          s.username = this.allUsers.find(u => u.UserId == s.user).FullName;
        })
      }
    }
  }

  closePopUp() {

    this.inputRecord = { date: new Date(), result: '', user: 0,PermitId:this.PermitId };
  }

  onRowEditInit(product: PTWGasTestRecord) {
    this.clonedProducts[product.id] = { ...product };
    delete this.clonedProducts[product.id];
  }

  saveRecord() {
    this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1 ;
    this.inputRecords.push({
      id: this.LastValueOfRecord, date: moment(
        moment.utc(this.inputRecord.date).local()
      ).toDate()
      , result: this.inputRecord.result, user: this.loggedInUserJSON.UserId, username: this.loggedInUserJSON.FullName,
      PermitId: this.PermitId
    });
    this.inputRecord = { date: new Date(), result: '', user: 0, PermitId: this.PermitId };
    this.productDialog = false;
    this.onGasRecordUpdate.emit(this.inputRecords);
  }

  onRowDeleteInit(index: number) {
    this.inputRecords.splice(index, 1);
    this.onGasRecordUpdate.emit(this.inputRecords);
  }
  onRowEditSave(product: PTWGasTestRecord, index: number) {
    this.inputRecords.splice(index, 1, product);
    this.onGasRecordUpdate.emit(this.inputRecords);
  }
  addRecord(){
    this.productDialog = true
    this.inputRecord.result = this.initialTextForTextArea;
  }
}
